import { version } from '../../package.json';

document.querySelector('.js-version').innerText = version;
